var map = {
	"./PunchoutListsDetailPage.tsx": 10744,
	"./PunchoutListsPage.tsx": 52595,
	"./RfqQuoteDetailPage.tsx": 73988,
	"./RfqQuotePage.tsx": 46095
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92274;